import * as React from "react";
import { cx, css } from "@emotion/css";
import bootstrapStyles from "../css/bootstrap.module.css";
import formGroupStyles from "../css/formgroup.module.css";
import { OCPFundEntryInterface } from "../support/interfaces/fundSelectionInterfaces";

interface PfFundSelectionOCP {
  birthYear: number;
  funds: OCPFundEntryInterface[];
  onOCPFundSelectionChanged: (arg0: OCPFundEntryInterface) => void;
  externalBindedValue: string;
}

export const PfFundSelectionOCP = ({
  birthYear,
  funds,
  onOCPFundSelectionChanged,
  externalBindedValue
}: PfFundSelectionOCP) => {
  const ocpFundOptionClass = css`
    display: block;
    margin-bottom: 1em;
    background: #f6f7f7;
    border: 2px solid #fff;
    padding: 1em;
    cursor: pointer;
    border-radius: 4px;
    float: left;
    width: 100%;
  `;

  const ocpFundOptionInputClass = css`
    display: inline-block;
    float: left;
  `;

  const fundNameClass = css`
    display: block;
    font-weight: 700;
  `;

  const fundRangeTextClass = css`
    font-weight: 300;
    display: block;
  `;

  return (
    <div>
      <div className={bootstrapStyles.row}>
        <div
          className={cx(
            bootstrapStyles["col-md-12"],
            formGroupStyles.contentPadding
          )}
        >
          {!Number.isNaN(birthYear) && (
            <p>
              Your birth year is <span id="dobYear">{birthYear}</span>.
            </p>
          )}
          <div className="language-pack-html" id="fundSelectionOcpMid">
            <p>
              American Century Investments has defaulted you to one of their One
              Choice Target Date Portfolios based on your birth year. These
              portfolios automatically adjust according to an assumed retirement
              age of 65. Please note that this is not investment advice.
            </p>
          </div>
        </div>
      </div>
      {funds.map((fund, index) => {
        return (
          <div className={bootstrapStyles["col-md-6"]} key={fund.fundCode}>
            <label
              htmlFor={fund.fundCode}
              id={`OCPFund${index}`}
              className={ocpFundOptionClass}
              style={
                fund.fundName === externalBindedValue
                  ? { border: "2px solid #0069a6" }
                  : {}
              }
            >
              <input
                className={ocpFundOptionInputClass}
                type="radio"
                id={fund.fundCode}
                value={fund.fundCode}
                checked={fund.fundName === externalBindedValue}
                onChange={() => {
                  onOCPFundSelectionChanged(fund);
                }}
              />
              <div className="ocpDescription">
                <span className={fundNameClass}>{fund.fundName}</span>
                <span className={fundRangeTextClass}>{fund.rangeText}</span>
              </div>
            </label>
          </div>
        );
      })}
    </div>
  );
};
